

    
<template>
  <div class="home-article">
    <div class="bg">
      <div class="article-innerbox">
        <div class="inner-title">{{ $t('m.feature.title') }}</div>

        <div class="inner-article">
          <ul class="article-ul">
            <li class="article-li" v-for="li, index in this.$store.state.InformationOne.posts" :key="index">
              <a @click="toArticle(li)">
                <p v-html="li.title.rendered">
                </p>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
 
<script>
import i18n from "../lang";
//此页为推荐文章
export default {
  name: "featured",
  inject: ['reload'],
  data() {
    return {
      list: [],
    };
  },
  watch: {
    '$route.query.id'() {
      if (this.$route.name == 'Article') {
        this.reload()
      }

    }
  },
  methods: {
    toArticle(item) {
      this.$router.push({
        path: '/article',
        query: {
          'id': item.id,
        }
      });
    }
  },

  created() { },
};
</script>
<style lang="scss" scoped>
@import "../assets/scss/featured.scss";
</style>